module.exports = __webpack_public_path__ + "img/Learn_About_Friends_Mobile.jpg";